import { useFeatureFlag } from "@Hooks/useFeatureFlag";
import { ReactNode } from "react";

interface IProps {
  identifier: string;
  children: ReactNode;
  fallback?: ReactNode;
  defaultValue: boolean;
}

export const FeatureFlag = ({ identifier, children, fallback = null, defaultValue }: IProps) => {
  const isEnabled = useFeatureFlag(identifier, defaultValue);

  return <>{isEnabled ? children : fallback}</>;
};
